import images from '@assets/images/index'
import { notification } from 'antd'
import { useEffect } from 'react'

import { Button } from '@suntex.fim/ui'

/**
 * define props type of SelectedRowPopUp
 */
type SelectedRowPopUpProps = {
  selectedRow: any
  resetRowSelection: any
  handleSendMessage: any
}

function SelectedRowPopUp({
  selectedRow,
  resetRowSelection,
  handleSendMessage
}: SelectedRowPopUpProps) {
  // for Send message notification
  const [api, contextHolder] = notification.useNotification()
  const openNotification = (
    placement:
      | 'top'
      | 'topLeft'
      | 'topRight'
      | 'bottom'
      | 'bottomLeft'
      | 'bottomRight',
    totalSelectedRaw: number
  ) => {
    api.open({
      key: 'updatable',
      description: (
        <>
          <div className="send-email-notification__content">
            <span className="fw-bold">&nbsp;{totalSelectedRaw}&nbsp;</span>
            Selected
          </div>
          <div className="send-email-notification__btn-container">
            <Button
              shape="round"
              intent="danger"
              onClick={() => {
                handleSendMessage()
                api.destroy()
              }}
              icon={<images.Send />}
              iconPosition="end"
            >
              Send a Message
            </Button>
          </div>
        </>
      ),
      duration: 0,
      placement,
      style: { zIndex: 999 },
      message: '',
      closeIcon: <images.CloseSimple />,
      className: 'send-email',
      onClose: () => {
        resetRowSelection()
      }
    })
  }
  const onRawSelectedChange = (selectedRaw: any) => {
    if (selectedRaw.length) {
      openNotification('bottom', selectedRaw.length)
    } else {
      api.destroy()
    }
  }

  useEffect(() => {
    onRawSelectedChange(selectedRow)
  }, [selectedRow.length])
  return (
    <>
      {' '}
      {/* contextHolder is for Send message notification */}
      {contextHolder}
      <div />
    </>
  )
}

export default SelectedRowPopUp
